import React, { useEffect, useState } from "react";
import styles from "./Dashboard.module.css";
import { fetchDashboardStats } from "../../services/dashboardService";
import { FaBoxOpen, FaWarehouse, FaMoneyBillWave, FaShoppingCart, FaChartLine } from 'react-icons/fa';

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalAssets: 0,
    totalLocations: 0,
    totalValue: 0, // Total Buy
    totalSold: 0,
    totalProfit: 0,
    recentAssets: [],
    recentLocations: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStats = async () => {
      const result = await fetchDashboardStats();
      if (result.success) {
        setStats(result.data);
      }
      setLoading(false);
    };
    loadStats();
  }, []);

  const formatCurrency = (val) => {
    if (!val) return '$0.00';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
  };

  return (
    <div className={styles["dashboard"]}>
      {/* Stats Grid */}
      <div className={styles["stats"]}>
        <div className={styles["stat-card"]}>
          <div className={`${styles.iconWrapper} ${styles.iconBlue}`}>
            <FaBoxOpen />
          </div>
          <div>
            <h3>Total Assets</h3>
            <p>{loading ? "..." : stats.totalAssets}</p>
          </div>
        </div>
        <div className={styles["stat-card"]}>
          <div className={`${styles.iconWrapper} ${styles.iconOrange}`}>
            <FaWarehouse />
          </div>
          <div>
            <h3>Total Containers</h3>
            <p>{loading ? "..." : stats.totalLocations}</p>
          </div>
        </div>
        <div className={styles["stat-card"]}>
          <div className={`${styles.iconWrapper} ${styles.iconRed}`}>
            <FaShoppingCart />
          </div>
          <div>
            <h3>Total Buy Cost</h3>
            <div className={styles.subtext}>Total Spend</div>
            <p>{loading ? "..." : formatCurrency(stats.totalValue)}</p>
          </div>
        </div>
        <div className={styles["stat-card"]}>
          <div className={`${styles.iconWrapper} ${styles.iconGreen}`}>
            <FaMoneyBillWave />
          </div>
          <div>
            <h3>Total Sold</h3>
            <div className={styles.subtext}>Revenue</div>
            <p>{loading ? "..." : formatCurrency(stats.totalSold)}</p>
          </div>
        </div>
        <div className={styles["stat-card"]}>
          <div className={`${styles.iconWrapper} ${styles.iconPurple}`}>
            <FaChartLine />
          </div>
          <div>
            <h3>Net Profit</h3>
            <div className={styles.subtext}>Sold Items Only</div>
            <p className={stats.totalProfit >= 0 ? styles.profit : styles.loss}>
              {loading ? "..." : formatCurrency(stats.totalProfit)}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.activityGrid}>
        {/* Recent Assets Section */}
        <div className={styles["activities"]}>
          <h2>Recently Added Assets</h2>
          {stats.recentAssets && stats.recentAssets.length > 0 ? (
            <ul>
              {stats.recentAssets.map((asset) => (
                <li key={asset.id}>
                  <div className={styles.activityRow}>
                    <strong>{asset.name}</strong>
                    <span className={styles.dateLabel}>
                      {asset.createdAt ? new Date(asset.createdAt).toLocaleDateString() : (asset.purchaseDate || 'N/A')}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className={styles.emptyText}>No recent assets found.</p>
          )}
        </div>

        {/* Recent Locations Section */}
        <div className={styles["activities"]}>
          <h2>Recently Added Containers</h2>
          {stats.recentLocations && stats.recentLocations.length > 0 ? (
            <ul>
              {stats.recentLocations.map((loc) => (
                <li key={loc.id}>
                  <div className={styles.activityRow}>
                    <strong>{loc.name}</strong>
                    <span className={styles.dateLabel}>
                      {loc.createdAt ? new Date(loc.createdAt).toLocaleDateString() : 'N/A'}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className={styles.emptyText}>No recent containers found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
